<app-breadcrumb [title]="'Forget Password'" [breadcrumb]="'Forget Password'"></app-breadcrumb>
<!-- section start -->
<section class="pwd-page">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 offset-lg-3">
                <h2>Forget Your Password</h2>
                <form class="theme-form">
                    <div class="form-row">
                        <div class="col-md-12">
                            <div class="sendSuccess" *ngIf="sendSuccess" >
                                {{sendSuccessMessage}}
                                <br>
                                <br>
                             </div> 
                         </div> 
                         <div class="col-md-12">
                            <div class="errorOccurred" *ngIf="errorOccurred" >
                                {{errorOccurredMessage}}
                                <br>
                                <br>
                             </div> 
                         </div> 
                        
                        <div class="col-md-12">
                            <input type="text" class="form-control" id="mobile" placeholder="Mobile" name="mobile" [(ngModel)]="mobile" required="">
                            <span class="errorOccurred" *ngIf="successMobile">{{errorMobileMessage}} <br></span>
                        </div>
                        <button class="btn btn-solid" (click)="userForgetPassword()">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>
<!--Section ends-->